import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext, useState } from "react";
import OtpInput from "react-otp-input";

import Button from "../button";

import "./style.css";

import { verifyCode } from "api/Auth";
import {
  getUserFromLocalStorage,
  storeUserInLocalStorage,
} from "hooks/LocalStorage";
import { useTranslation } from "i18n";

import { CurrencyContext } from "pages/useContext";

function VerifyCode({ email, handleClose }) {
  const { t } = useTranslation();
  const [Otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [sucess, setSuccess] = useState("");
  const { setCurrency } = useContext(CurrencyContext);

  const handleChange = (otp) => {
    setOtp(otp);
  };

  const handelSubmit = async () => {
    setErr("");
    setSuccess("");

    if (!Otp) {
      setErr(
        "Please enter the verification code you received over email or SMS"
      );
      return;
    }

    setLoading(true);

    try {
      const res = await verifyCode({ email, verificationToken: Otp });

      if (!res?.ok) {
        setErr(res?.data?.errorDetails || "An unknown error occurred");
        return; // Stop further execution if the response is not OK
      }

      setSuccess(res?.data?.message);

      const { authenticationToken, refreshToken } =
        res?.data?.authenticationToken || {};

      if (authenticationToken && refreshToken) {
        const token = {
          authenticationToken,
          refreshToken,
        };
        storeUserInLocalStorage(token);

        const getTokenData = getUserFromLocalStorage();
        window.dispatchEvent(new Event("storage"));

        //*********** Store currency in Local Storage ************//

        // setCurrency({
        //   tokenCurrency: getTokenData?.registeredFrom,
        // });

        setTimeout(() => handleClose(), 1500);
      } else {
        setErr(t("auth.missingToken"));
      }
    } catch (error) {
      setErr(t("auth.verifyError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-modal">
      <div className="login-modal__glow" />
      <p className="login-modal__brand">{t("home.appBrand")}</p>
      <h1 className="login-modal__title">{t("auth.verifyCode")}</h1>
      {err && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {err}
        </Alert>
      )}
      {sucess && (
        <Alert severity="success" sx={{ mb: 1 }}>
          {sucess}
        </Alert>
      )}
      <OtpInput
        value={Otp}
        onChange={handleChange}
        numInputs={4}
        shouldAutoFocus={true}
        inputStyle="input-otp"
        containerStyle="input-otp-container"
      />

      <p className="login-modal__footer" style={{ marginBottom: 16 }}>
        {t("auth.noEmail")}{" "}
        <button type="button" className="login-modal__link" onClick={handelSubmit}>
          {t("auth.resend")}
        </button>
      </p>

      <Button
        onClick={handelSubmit}
        type="submit"
        className="bigBtn w-100 primary-color"
      >
        {loading ? (
          <CircularProgress sx={{ color: "#fff" }} size={22} />
        ) : (
          t("common.submit")
        )}
      </Button>
    </div>
  );
}

export default VerifyCode;
